import Trolley from './Trolley';

export default Trolley;
